import Vuex from 'vuex'
import Cookies from 'js-cookie'
import Vue from 'vue'
import {
  getLoginUsersToken,
  getLoginUsersId,
  removeLoginUsersToken,
  removeLoginUsersId,
  isAuthenticated
} from '@/utils/auth'
import {
  migrateAuthStorage,
  getAuthItem,
  setAuthItem,
  clearAuthStorage,
  parseAuthJson
} from '@/utils/authStorage'
import { jsonFormData } from '@/utils/jsonFormData';
import request from '@/utils/request'

Vue.use(Vuex)

migrateAuthStorage()

const store = new Vuex.Store({
  state: {
    token: getLoginUsersToken(),
    isLoggedIn: getAuthItem('isLoggedIn') || null,
    isRole: getAuthItem('isRole') || '0',
    userInfo: parseAuthJson('userInfo'),
    area: sessionStorage.getItem('area') || '1',
    auditStatus: getAuthItem('auditStatus') || '0',
    unreadMessages: 0,
    role: getAuthItem('role') || '0',
    activeName: '',
    qualification: 0
  },
  mutations: {
    setQualification(state, activeName) {
      state.qualification = activeName;
    },
    setActiveName(state, activeName) {
      state.activeName = activeName;
    },
    setUserGender(state, headPic) {
      if (state.userInfo) {
        state.userInfo.headPic = headPic;
        setAuthItem('userInfo', JSON.stringify(state.userInfo));
      }
    },
    setCounts(state, messages) {
      state.unreadMessages = messages;
    },
    changeAuditStatus(state, auditStatus) {
      state.auditStatus = auditStatus;
      setAuthItem('auditStatus', auditStatus);
    },
    changeArea(state, area) {
      state.area = area;
      sessionStorage.setItem('area', area);
    },
    login(state, info) {
      setAuthItem('isLoggedIn', '1');
      setAuthItem('userInfo', JSON.stringify(info));
      state.isLoggedIn = '1';
      state.userInfo = info;
    },
    logout(state) {
      Cookies.remove('LoginUsersToken');
      Cookies.remove('LoginUsersId');
      clearAuthStorage();
      state.isLoggedIn = null;
      state.userInfo = null;
      state.isRole = '0';
      state.auditStatus = '0';
      state.qualification = 0;
      state.token = '';
    },
    syncLogoutFromStorage(state) {
      state.isLoggedIn = null;
      state.userInfo = null;
      state.isRole = '0';
      state.auditStatus = '0';
      state.qualification = 0;
      state.token = '';
    },
    syncSessionFromStorage(state) {
      state.token = getLoginUsersToken() || '';
      state.isLoggedIn = getAuthItem('isLoggedIn') || null;
      state.isRole = getAuthItem('isRole') || '0';
      state.userInfo = parseAuthJson('userInfo');
      state.auditStatus = getAuthItem('auditStatus') || '0';
      state.role = getAuthItem('role') || '0';
    },
    changeIsRole(state, isRole) {
      state.isRole = isRole
      setAuthItem('isRole', isRole);
    },
    changeRoles(state, role) {
      state.role = role
      setAuthItem('role', role);
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },
  actions: {
    initAuth({ commit, state }) {
      return new Promise((resolve) => {
        migrateAuthStorage()

        if (!isAuthenticated()) {
          commit('logout')
          resolve()
          return
        }

        const token = getLoginUsersToken()
        commit('SET_TOKEN', token)

        request({
          url: 'users/personalCenterApi/queryLoginUsersDetail',
          method: 'POST',
          data: jsonFormData({}),
          silent: true
        }).then((res) => {
          const userInfo = {
            ...res.data,
            id: res.data.id || getLoginUsersId()
          }
          commit('login', userInfo)
          if (!getAuthItem('isRole') || getAuthItem('isRole') === '0') {
            const roleId = userInfo.roleId
            if (Array.isArray(roleId) && roleId.length) {
              commit('changeIsRole', String(roleId[0]))
            }
          }
          resolve()
        }).catch(() => {
          commit('logout')
          removeLoginUsersToken()
          removeLoginUsersId()
          resolve()
        })
      })
    },
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        request({
          url: 'noLogins/users/userAccountsApi/usersLogin',
          method: 'POST',
          data: jsonFormData(userInfo)
        }).then((res) => {
          if(res.state == 10200) {
            let response = res.data;
            Cookies.set('LoginUsersToken', response.loginToken);
            Cookies.set('LoginUsersId', response.id);
            commit('login', response)
            commit('changeIsRole', userInfo.roleId)
            commit('SET_TOKEN', response.loginToken)
            commit('changeRoles', '0')
          }
          resolve()
        }).catch(error=>{
          if(error.state == 10310 || error.state == 10311) {
            let response = error.data;
            Cookies.set('LoginUsersToken', response.loginToken);
            Cookies.set('LoginUsersId', response.id);
            commit('changeRoles', userInfo.roleId)
          }
          reject(error)
        });
      })
    },

    LogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('logout')
        removeLoginUsersToken()
        removeLoginUsersId()
        commit('changeRoles', '0')
        resolve()
      })
    },
    attachmentDownload({ commit }) {
      let data = {};
      request({
        url: 'users/pcIndexApi/queryNoReadNoticesCounts',
        method: 'POST',
        data: jsonFormData(data)
      }).then((res) => {
        commit('setCounts', res.data);
      }).catch((error) => {
        console.error('Failed to fetch unread notices counts:', error);
      });
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js